import React, { useState } from 'react'
import { IconCheck, IconPencil, IconTrash, IconX } from '@tabler/icons-react'
import { Draggable } from 'react-beautiful-dnd'

import { Button } from '@/components/buttons/Button'
import { Card } from '@/components/cards/Card'
import { Pill } from '@/components/pills/Pill'
import { TextInput } from '@/components/forms/TextInput'
import { DragAndDropButton } from '@/components/dragDrop/DragAndDropButton'

import { TagList } from './TagList'

export const CategoryCard = ({
  column,
  index,
  tags,
  edit_users,
  deleteCategory,
  updateCategory,
  deleteTag,
}) => {
  const [editing, setEditing] = useState(false)
  const [title, setTitle] = useState(column.title)

  const handleTitleChange = (event) => {
    setTitle(event.target.value)
  }

  const handleToggleEditing = () => {
    if (editing) {
      setTitle(column.title)
    }
    setEditing((prev) => !prev)
  }

  const handleSubmit = (event) => {
    event.preventDefault()
    updateCategory(column, title)
    setEditing(false)
  }

  return (
    <Draggable draggableId={column.id.toString()} index={index} isDragDisabled={!edit_users}>
      {(provided, snapshot) => (
        <div
          className="manage-tags__category-card"
          data-testid="category-card"
          ref={provided.innerRef}
          {...provided.draggableProps}
        >
          <Card compact fullHeight className="no-margin">
            <header className="module-card-section-header">
              <DragAndDropButton provided={provided} snapshot={snapshot} readOnly={!edit_users} />
              {editing ? (
                <form className="manage-tags__edit-category" onSubmit={handleSubmit}>
                  <TextInput
                    autoFocus
                    data-testid="edit_category_text_box"
                    placeholder={title}
                    value={title}
                    onChange={handleTitleChange}
                  />
                  <Button
                    square
                    small
                    brand
                    type="submit"
                    data-testid="edit_category_button"
                    aria-label={`Save name for category ${column.title}`}
                    tooltip="Save"
                  >
                    <IconCheck />
                  </Button>
                </form>
              ) : (
                <>
                  <h3>{column.title}</h3>
                  <Pill xs>{tags.length}</Pill>
                </>
              )}
              {edit_users && (
                <div className="manage-tags__card-actions ml-auto">
                  <Button
                    square
                    basic
                    small
                    data-testid="edit_category_toggle"
                    aria-label={editing ? 'Discard changes' : `Edit category ${column.title}`}
                    tooltip={editing ? 'Discard changes' : 'Edit category'}
                    onClick={handleToggleEditing}
                  >
                    {editing ? <IconX /> : <IconPencil />}
                  </Button>
                  <Button
                    square
                    basic
                    small
                    data-testid="delete_category"
                    aria-label={`Delete category ${column.title}`}
                    tooltip="Delete category"
                    onClick={() => deleteCategory(column)}
                  >
                    <IconTrash />
                  </Button>
                </div>
              )}
            </header>
            <TagList column={column} tags={tags} deleteTag={deleteTag} />
          </Card>
        </div>
      )}
    </Draggable>
  )
}
